import * as React from 'react';
import FormControlContext from './FormControlContext';
export default function useFormControl() {
  return React.useContext(FormControlContext);
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/FormControl/useFormControl.js
// module id = 261
// module chunks = 121